<template>
  <div class="adm-tabs--scroll-area">
    <div class="adm-tabs--scroll-content">
      <slot />
    </div>
  </div>
</template>
